<div class="layout-grid-container" [class.sidebar-collapsed]="isSidebarCollapsed">
  <!-- Mobile backdrop -->
  <div class="mobile-backdrop" *ngIf="isMobile" [class.show]="!isSidebarCollapsed" (click)="isSidebarCollapsed = true">
  </div>

  <app-sidebar [isCollapsed]="isSidebarCollapsed" class="sidebar-area"></app-sidebar>

  <div class="content-area">
    <app-header (sidebarToggle)="toggleSidebar()" class="header-area"></app-header>
    <main class="main-content" #mainContent (scroll)="onScroll($event)">
      <router-outlet></router-outlet>

      <!-- Scroll to top button -->
      <button class="scroll-to-top" [class.show]="showScrollTopButton" (click)="scrollToTop()"
        aria-label="Scroll to top">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="18 15 12 9 6 15"></polyline>
        </svg>
      </button>
    </main>
  </div>
</div>

<app-task-modal-upsert *ngIf="taskModalService.isOpen()" [taskId]="taskModalService.taskId()"
  (close)="taskModalService.close()">
</app-task-modal-upsert>